import React from 'react';
import type { BuiltResume } from '../../../resume-engine/types';

interface Props {
  contact: BuiltResume['contact'];
  ats?: boolean;
}

export function ResumeHeader({ contact, ats = false }: Props) {
  return (
    <header className={ats ? 'resume-ats-header' : 'resume-header'}>
      <h1 className="resume-name">{contact.name}</h1>
      <p className="resume-title">{contact.title}</p>
      <div className="resume-contact-row">
        <span>{contact.email}</span>
        <span className="resume-sep">|</span>
        <span>{contact.location}</span>
        <span className="resume-sep">|</span>
        <a href={contact.linkedin} target="_blank" rel="noreferrer">LinkedIn</a>
        <span className="resume-sep">|</span>
        <a href={contact.github} target="_blank" rel="noreferrer">GitHub</a>
        <span className="resume-sep">|</span>
        <a href={contact.website} target="_blank" rel="noreferrer">Portfolio</a>
      </div>
    </header>
  );
}
